<template>
  <div class="menu unselect">
    <div class="menu__buttons">
      <router-link
        to="/dashboard"
        tag="button"
        class="menu__btn"
        active-class="menu__btn-active"
      >
        Дашборд
      </router-link>
      <router-link
        to="/dashboard/checks"
        tag="button"
        class="menu__btn"
        active-class="menu__btn-active"
      >
        Проверки
      </router-link>
      <router-link
        to="/dashboard/donors"
        tag="button"
        class="menu__btn"
        active-class="menu__btn-active"
        >Доноры
      </router-link>
      <router-link
        to="/dashboard/import"
        tag="button"
        class="menu__btn"
        active-class="menu__btn-active"
        >Импорт доноров
      </router-link>
       <router-link
        to="/dashboard/proxy"
        tag="button"
        class="menu__btn"
        active-class="menu__btn-active"
        >Прокси
      </router-link>
      <router-link
        to="/dashboard/settings"
        tag="button"
        class="menu__btn"
        active-class="menu__btn-active"
        >Настройки
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardMenu',
};
</script>

<style scoped>
.menu {
  display: flex;
  align-items: center;
  /* justify-content: center; */
  /* margin: 46px 0 0 0; */
  /* padding: 0px 15px;
  background: #f1f1f1; */
  padding: 5px 15px;
  background: #eeeded;
}

.menu__buttons {
  display: flex;
  align-items: center;
  overflow: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.menu__buttons::-webkit-scrollbar {
  display: none;
}

.menu__btn {
  /* display: none; */
  align-items: center;
  /* position: fixed; */
  /* right: 10px; */
  /* width: 26px; */
  /* height: 26px; */
  cursor: pointer;
  padding: 5px 10px;
  cursor: pointer;
  margin: 0 5px 0 0;
  font-family: inherit;
  border: 0;
  font-size: 16px;
  outline: 0;
  color: #262a2d;
  /* background: #333; */
  text-decoration: none;
}

.menu__btn-active,
.menu__btn:hover {
  /* background: #333333; */
  background: #5a5a5a;
  color: #ffffff;
  border-radius: 5px;
}
</style>